module.exports = __webpack_public_path__ + "img/141.3a5bb1a0.jpg";